export const EXPERIMENT_TOP_BAR_TOGGLE = 'specs.wixForum.TopBarToggle';
export const EXPERIMENT_PERFORMANCE_METRICS = 'specs.wixForum.PerformanceMetrics';
export const EXPERIMENT_SNAPPY_TURBO = 'specs.wixForum.SnappyTurbo';
export const EXPERIMENT_DISABLE_GET_STYLE_PARAMS = 'specs.wixForum.DisableGetStyleParams';
export const EXPERIMENT_USE_SDK_PERFORMANCE_DECORATOR = 'specs.wixForum.UseSdkPerformanceDecorator';
export const EXPERIMENT_DISABLE_MODAL_PRELOAD_MOBILE = 'specs.wixForum.DisableModalPreloadOnMobile';
export const EXPERIMENT_CAPTCHA = 'specs.wixForum.Captcha';
export const EXPERIMENT_SHOW_SUBCATEGORIES_TOGGLE = 'specs.wixForum.ShowSubcategoriesToggle';
export const EXPERIMENT_FOOTER_POSTS = 'specs.wixForum.FooterPosts';
export const EXPERIMENT_FILE_UPLOAD = 'specs.wixForum.FileUploadNew';
export const EXPERIMENT_RENDER_SEO_TAGS = 'specs.wixForum.RenderSeoTags';
export const EXPERIMENT_PRIVATE_CATEGORIES = 'specs.wixForum.PrivateCategories';
export const EXPERIMENT_MARK_AS_SOLVED = 'specs.wixForum.MarkAsSolved';
